

const ValidarPermiso = (permiso, permisos) => {
  return ( permisos.indexOf(permiso))
}

export default ValidarPermiso
